const fieldName = {
  text: 'textValue',
  number: 'numberValue',
  date: 'dateValue',
  file: 'file',
  image: 'image'
};

export default fieldName;
